import { render, staticRenderFns } from "./InventoryListItem.vue?vue&type=template&id=2503061a&scoped=true&"
import script from "./InventoryListItem.vue?vue&type=script&lang=js&"
export * from "./InventoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./InventoryListItem.vue?vue&type=style&index=0&id=2503061a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503061a",
  null
  
)

export default component.exports